import { gql } from '@apollo/client'

const GET_WATCHER = gql`
  query getWatcher($idWatcher: UUID!) {
    watcher(id: $idWatcher) {
      nickname
      firstname
      email
      lastname
      phoneNumber
      companyByIdCompany {
        id
        name
        siret
        tvaNumber
      }
      formattedAddress
      postcode
      addressLine1
      addressLine2
      cityName
      countryName
      consentNewsletter
    }
  }
`

export default GET_WATCHER
